import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  SUPPORTED_LANGUAGES,
  LANGUAGE_CODE_MAP,
} from 'Store/locales/constants';
import changeActiveLanguage from 'Store/locales/actions';

class LanguageSwitcher extends React.PureComponent {
  onLanguageSelect = e => {
    this.props.changeActiveLanguage(e.target.value);
  };

  render() {
    return (
      <div className="LanguageSwitcher">
        <select
          className="LanguageSwitcher__select"
          onChange={this.onLanguageSelect}
          defaultValue={this.props.activeLanguage}
        >
          {SUPPORTED_LANGUAGES.map(lang => {
            const label = LANGUAGE_CODE_MAP[lang]
              ? LANGUAGE_CODE_MAP[lang]
              : lang;
            return (
              <option value={lang} key={lang}>
                {label}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeLanguage: state.locales.active,
  };
};

LanguageSwitcher.propTypes = {
  activeLanguage: PropTypes.oneOf(SUPPORTED_LANGUAGES),
  changeActiveLanguage: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeActiveLanguage })(
  LanguageSwitcher
);
